<template>
  <div>
    <div v-if="running" class="text-xs-center progress-div">
      <div class="progress-div-content">
        <div>
          <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="15"
            :value="progress"
            color="primary"
          >{{ progress }}</v-progress-circular>
          <div>Mise à jour des données des étudiants en cours</div>
        </div>
      </div>
    </div>
    <div v-else-if="students">
      <v-card>
        <v-layout justify-space-between pa-3>
          <student-list :students="students" :setActive="setActive" :setOpen="setOpen"/>
          <student-detail
            :selected="selected"
            :updating="updating"
            :toggleUpdateDialog="toggleUpdateDialog"
            :toggleSendOneDialog="toggleSendOneDialog"
            :setUpdating="setUpdating"
            :setStudent="setStudent"
            :openMessage="openMessage"
            :active="active"
          />
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn flat @click="toggleSendDialog">Envoyer les bulletins</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat @click="toggleUpdateAllDialog">Import complet</v-btn>
        </v-card-actions>
      </v-card>
      <update-dialog
        :updateAsync="this.updateAsync"
        :updateDialog="this.updateDialog"
        :toggleDialog="this.toggleUpdateDialog"
        :updating="this.updating"
        :modeleId="this.selected ? this.selected.modeleId : ''"
        title="Mise à jour d'un bulletin"
        message="Attention : la version actuelle du bulletin sera perdue."
      />
      <update-dialog
        :updateAsync="this.updateAllAsync"
        :updateDialog="this.updateAllDialog"
        :toggleDialog="this.toggleUpdateAllDialog"
        :updating="this.updating"
        :modeleId="this.students && this.students[0] ? this.students[0].modeleId : '5686811082'"
        title="Mise à jour complète"
        :message="`Attention : toutes les données seront remplacées. Le temps estimé pour cette mise à jour est de ${importDuration} minutes.`"
      />
      <send-dialog
        :sendEmails="this.sendEmails"
        :sendDialog="this.sendDialog"
        :updating="this.updating"
        :toggleDialog="this.toggleSendDialog"
        :students="this.students"
      />
      <send-one-dialog
        :sendOneDialog="this.sendOneDialog"
        title="Envoi d'un bulletin"
        message="Attention : en cliquant sur envoyer, le bulletin sera envoyé en pièce jointe à l'étudiant selectionné."
        :sendEmail="this.sendEmail"
        :updating="this.updating"
        :toggleDialog="this.toggleSendOneDialog"
      />
      <v-snackbar v-model="messageOpen" :bottom="true">
        {{ message }}
        <v-btn color="pink" flat @click="messageOpen = false" :timeout="6000">Fermer</v-btn>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import UpdateDialog from "./UpdateDialog";
import SendDialog from "./SendDialog";
import StudentList from "./StudentList";
import StudentDetail from "./StudentDetail";
import SendOneDialog from "./SendOneDialog";

export default {
  sockets: {
    progress: function(data) {
      this.running = data.running;
      this.progress = data.progress;
      if (this.progress === 100) {
        this.students = data.students;
        setTimeout(() => {
          this.running = false;
          this.progress = 0;
          this.openMessage("Données synchronisées");
        }, 1000);
      }
    }
  },
  props: ["keycloak"],
  components: {
    UpdateDialog,
    SendOneDialog,
    SendDialog,
    StudentList,
    StudentDetail
  },
  data: () => ({
    loading: false,
    students: undefined,
    updateDialog: false,
    updateAllDialog: false,
    sendDialog: false,
    sendOneDialog: false,
    updating: false,
    user: undefined,
    message: "",
    messageOpen: false,
    running: false,
    progress: 0,
    active: [],
    open: [],
    importDuration: 0
  }),
  computed: {
    selected() {
      if (!this.active.length) return undefined;

      const id = this.active[0];

      return this.students.find(student => student._id === id);
    }
  },
  async mounted() {
    if (this.keycloak && this.keycloak.token) {
      this.$socket.io.opts.query = `token=${this.keycloak.token}`;
      this.$socket.connect();
      this.loading = true;
      try {
        const { data: progressData } = await axios(
          `${process.env.VUE_APP_API_URL}/running`,
          {
            method: "GET"
          }
        );
        const { data } = await axios(
          `${process.env.VUE_APP_API_URL}/students`,
          {
            method: "GET"
          }
        );
        const { running, progress, toProcess } = progressData;
        this.students = data;
        this.running = running;
        this.progress = progress;
        this.importDuration = Math.ceil((toProcess * 20) / 60);
      } catch (e) {
        if (e.response.status === 403) {
          this.keycloak.logout();
        }
      }
    }
  },
  methods: {
    setUpdating: function(updating) {
      this.updating = updating;
    },
    setActive: function(active) {
      this.active = active;
    },
    setOpen: function(open) {
      this.open = open;
    },
    setStudent: function(data) {
      Object.assign(
        this.students.find(student => student._id === data._id),
        data
      );
    },
    logout: function() {
      this.keycloak.logout();
    },
    openMessage: function(message) {
      this.message = message;
      this.messageOpen = true;
    },
    sendEmails: async function(mailingList) {
      this.updating = true;
      const { data } = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_API_URL}/students/send`,
        data: { mailingList }
      });
      data.map(s => {
        Object.assign(this.students.find(student => s._id === student._id), s);
      });
      this.sendDialog = false;
      this.updating = false;
      this.openMessage(`Bulletins envoyés à ${data.length} étudiants`);
    },
    sendEmail: async function() {
      this.updating = true;
      const { data } = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_API_URL}/students/${this.active[0]}/send`
      });
      this.student = data;
      this.sendOneDialog = false;
      this.updating = false;
      this.openMessage(`Bulletin envoyé à ${data.firstName} ${data.lastName}`);
    },
    toggleUpdateDialog: function() {
      this.updateDialog = !this.updateDialog;
    },
    toggleUpdateAllDialog: function() {
      this.updateAllDialog = !this.updateAllDialog;
    },
    toggleSendDialog: function() {
      this.sendDialog = !this.sendDialog;
    },
    toggleSendOneDialog: function() {
      this.sendOneDialog = !this.sendOneDialog;
    },
    updateAsync: async function(modeleId) {
      this.updating = true;
      const { data } = await axios({
        method: "PUT",
        data: { modeleId },
        url: `${process.env.VUE_APP_API_URL}/students/${this.active[0]}`,
        headers: {
          "content-type": "application/json"
        }
      });
      this.students.find(student => student._id === data._id).generatedAt =
        data.generatedAt;
      this.students.find(student => student._id === data._id).modeleId =
        data.modeleId;

      this.updateDialog = false;
      this.updating = false;
      this.openMessage(
        `Bulletin de ${data.firstName} ${data.lastName} mis à jour`
      );
    },
    updateAllAsync: async function(modeleId) {
      this.updating = true;
      await axios({
        method: "POST",
        data: { modeleId },
        url: `${process.env.VUE_APP_API_URL}/students`
      });
      this.active = [];
      this.open = [];
      this.updateAllDialog = false;
      this.running = true;
      this.updating = false;
    },
    closeMessage: function() {
      this.message = "";
      this.messageOpen = false;
    }
  }
};
</script>

<style scoped>
.sticky {
  height: 400px;
  position: sticky;
  top: 0;
}
.v-progress-circular {
  margin: 1rem;
}
.progress-div {
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fafafa; /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.progress-div-content {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
